document.addEventListener('DOMContentLoaded', function () {
  const messages = document.querySelectorAll('.announcement-bar__message');
  if (messages.length < 2) return;

  let current = 0;

  setInterval(function () {
    messages[current].classList.remove('active');
    current = (current + 1) % messages.length;
    messages[current].classList.add('active');
  }, 3000);
});
